import * as ActionType from '../constants/constant_action_types';

export function setPurchaseOrderPagination( page, perPage, totalRows ) {
  return { type: ActionType.SET_ENTITY_PURCHASE_ORDER_PAGINATION, page, perPage, totalRows };
}

export function getPurchaseOrders(filters) {
  return { type: ActionType.GET_ENTITY_PURCHASE_ORDERS, filters }; 
}

export function setPurchaseReceiptPagination( page, perPage, totalRows ) {
  return { type: ActionType.SET_ENTITY_PURCHASE_RECEIPT_PAGINATION, page, perPage, totalRows };
}

export function getPurchaseReceipts(filters) {
  return { type: ActionType.GET_ENTITY_PURCHASE_RECEIPTS, filters }; 
}

export function setPurchaseReturnPagination( page, perPage, totalRows ) {
  return { type: ActionType.SET_ENTITY_INVENTORY_RETURN_PAGINATION, page, perPage, totalRows };
}

export function getPurchaseReturns(filters) {
  return { type: ActionType.GET_ENTITY_INVENTORY_RETURN, filters }; 
}